import { addMessages } from '@hana/i18n';

// Khoá chuỗi mpad.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'mpad.1': "Ghép",
  'mpad.2': "Tạo dòng phát sinh",
  'mpad.3': "Hỏi Hana",
});
addMessages('en', {
  'mpad.1': "Match",
  'mpad.2': "Create adjustment line",
  'mpad.3': "Ask Hana",
});
